import { Text } from '@vkontakte/vkui';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { QuotaLandingSelectors } from 'reactApp/modules/quotaLanding/quotaLanding.selector';
import { Button, ButtonSizeMode, ButtonVariant } from 'reactApp/ui/Button/Button';
import { useBuyCleanerTariff } from 'reactApp/ui/QuotaCleanerPage/hooks/useBuyCleanerTariff';

import styles from './QuotaCleanerSpacePromo.css';

const messages = {
    mainText: 'Увеличьте место, чтобы не удалять файлы.',
    additionalText: `128 ГБ в Облаке и Почте без рекламы всего за 1 ₽!`,
};

interface SpacePromoProps {
    isIOSPromo?: boolean;
    isAndroidPromo?: boolean;
    isMobilePayAvailable?: boolean;
}

export const QuotaCleanerSpacePromo: FC<SpacePromoProps> = ({ isIOSPromo, isAndroidPromo, isMobilePayAvailable }) => {
    const isMobile = useSelector(QuotaLandingSelectors.isMobile);
    const { tariffPrice, onBuy } = useBuyCleanerTariff(isMobilePayAvailable, isIOSPromo, isAndroidPromo);
    if (!tariffPrice) {
        return null;
    }

    return (
        <div className={styles.wrapper} data-qa-id="quota-cleaner-space-promo">
            <div className={styles.text}>
                <Text Component="h6" weight="2">
                    {messages.mainText}
                </Text>
                {isMobile && (
                    <Text Component="h6" weight="3" className={styles.textAdditional}>
                        {messages.additionalText}
                    </Text>
                )}
            </div>

            <div className={styles.button}>
                <Button theme="octavius" sizeMode={ButtonSizeMode.extraSmall} variant={ButtonVariant.contrast} onClick={onBuy}>
                    <Text Component="h6" weight="2">{`Купить за ${tariffPrice} ₽ в месяц`}</Text>
                </Button>
            </div>
        </div>
    );
};
